import { connect } from 'react-redux';
import { sendingError } from '../actions/ErrorActions';

import ErrorBoundary from '../ErrorBoundary';

const mapStateToProps = state => ({
  errorBoundary: state.error.errorBoundary,
  errorApi: state.error.errorApi,
  pathname: state.router.location.pathname,
});

const mapDispatchToProps = dispatch => ({
  sendingError: params => dispatch(sendingError(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorBoundary);
